import AdUnit from "./AdUnit";
import { ADSENSE_IN_FEED_SLOT } from "../../config/adsense.js";

export default function InFeedAd() {
  return (
    <AdUnit
      slot={ADSENSE_IN_FEED_SLOT}
      className="ad-slot--infeed"
      format="fluid"
      layout="in-feed"
      style={{ display: "block" }}
      fullWidthResponsive="true"
    />
  );
}
